import { render, staticRenderFns } from "./Question504.vue?vue&type=template&id=81fa214a&"
import script from "./Question504.vue?vue&type=script&lang=ts&"
export * from "./Question504.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports